module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門3_6.7d13dec4.png";